<template>
  <div class="tab-card-bd">
    <div :class="['give-the-thumbs-up', isAlreadyUpvote ? 'done' : '']" @click="addUpvoteCount">
      <span class="thumbs-icon"></span>
      {{ veEvaluate.upvote_count || 0 }}
    </div>

    <common-exclusive-service-card :exclusive-data="exclusiveData" @close="$emit('close')">
      <template #info>
        <div class="card-info">
          <!-- 标签 -->
          <div class="label-list" v-if="labelList && labelList.length">
            <div :class="['lable-item', labelColorList[index] || 'red']" v-for="(label, index) in labelList">{{ label }}</div>
          </div>

          <!-- 分数 -->
          <div class="score-list">
            <div class="score-item">
              <div class="score-number">{{ veEvaluate.score/100 || 0 }}</div>
              <div class="score-label">评分</div>
            </div>
            <div class="score-item">
              <div class="score-number">{{ veEvaluate.service_count || 0 }}</div>
              <div class="score-label">累计服务</div>
            </div>
            <div class="score-item">
              <div class="score-number">{{ veEvaluate.evaluate_count || 0 }}</div>
              <div class="score-label">累计评价</div>
            </div>
          </div>

          <!-- 评论 -->
          <div class="recommend" v-if="exclusiveData.order_review">
            <img src="@/assets/imgs/homepage/fixed-right-service/exclusive-service/default-header.png" alt="">
            <span class="company">深圳**旅行社</span>
            <!-- 服务耐心，解决了五名客人的问题，点赞！ -->
            <span class="text">{{ exclusiveData.order_review  }}</span>
          </div>
        </div>
      </template>
    </common-exclusive-service-card>

  </div>
</template>

<script>
import Http from '@/libs/http';
import User from '@/libs/user';
import CommonExclusiveServiceCard from './common-exclusive-service-card.vue';
import { mapMutations } from 'vuex';
import { SET_CS_DATA } from '@/store/modules/user/user-mutation-types';
import utils from '@/libs/utils';


export default {
  props: {
    exclusiveData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CommonExclusiveServiceCard,
  },
  data() {
    return {
      labelColorList: ['red', 'orange', 'blue'],
      isAlreadyUpvote: false,
    };
  },
  created() {
    const upvoteCountMapStr = localStorage.getItem('csUpvoteCountMap');
    const upvoteCountMap = upvoteCountMapStr ? JSON.parse(upvoteCountMapStr) : undefined;
    if (!upvoteCountMap || !upvoteCountMap[User.peer_account_id]) return;
    // 还得处理客服更换情况
    const flag = upvoteCountMap[User.peer_account_id].includes(this.exclusiveData.oss_account_id);
    this.isAlreadyUpvote = flag;
  },
  computed: {
    veEvaluate() {
      if (!this.exclusiveData) return {};
      return this.exclusiveData.ve_evaluate || {};
    },
    labelList() {
      if (!this.exclusiveData) return [];
      const firstLabel = this.exclusiveData.service_label;
      const veEvaluateLabelList = this.veEvaluate.label_set || [];
      const labelList = firstLabel ? [firstLabel, ...veEvaluateLabelList] : veEvaluateLabelList;
      return labelList.slice(0, 3);
    },
  },
  methods: {
    ...mapMutations('user/', [
      SET_CS_DATA,
    ]),
    addUpvoteCount() {
      if (this.isAlreadyUpvote) return;
      // 更新点赞数
      Http.post('/ve_upvote', {
        oss_account_id: this.exclusiveData.oss_account_id,
      }, { noToast: true }).then(() => {
        this.updateUpvoteCountToLocal();
        this.isAlreadyUpvote = true;
        this.updateCsData();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    updateCsData() {
      const veEvaluateCopy = utils.deepCopy(this.veEvaluate);
      veEvaluateCopy.upvote_count += 1;
      this.SET_CS_DATA({
        ...this.exclusiveData,
        ve_evaluate: veEvaluateCopy,
      });
    },
    // 更新点赞数到本地
    updateUpvoteCountToLocal() {
      const upvoteCountMapStr = localStorage.getItem('csUpvoteCountMap');
      const upvoteCountMap = upvoteCountMapStr ? JSON.parse(upvoteCountMapStr) : {};
      upvoteCountMap[User.peer_account_id] = upvoteCountMap[User.peer_account_id] || [];
      upvoteCountMap[User.peer_account_id].push(this.exclusiveData.oss_account_id);
      localStorage.setItem('csUpvoteCountMap', JSON.stringify(upvoteCountMap));
    },
  },
};
</script>

<style lang="less" scoped>
.tab-card-bd {
  position: relative;
  .give-the-thumbs-up {
    position: absolute;
    right: 32px;
    top: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #91999F;
    line-height: 14px;
    cursor: pointer;
    user-select: none;
    &.done {
      color: #599FFF;

      .thumbs-icon {
        background-image: url(../../../../../assets/imgs/homepage/fixed-right-service/exclusive-service/thumbs-active.png);
      }
    }
    .thumbs-icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
      background: url(../../../../../assets/imgs/homepage/fixed-right-service/exclusive-service/thumbs.png) no-repeat center / 100% 100%;
      background-size: 100% 100%;

    }
  }
  .card-info {
    padding-top: 8px;
    padding-bottom: 24px;
    .label-list {
      display: flex;
      align-items: center;
      justify-content: center;
      .lable-item {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        border-radius: 1px;
        font-size: 12px;
        line-height: 12px;
        margin-left: 8px;
        padding: 4px;
        max-width: 33%;
        &:first-child {
          margin-left: 0;
        }
        &.red {
          background: rgba(244,69,92,0.08);
          border: 1px solid rgba(255,100,100,0.2);
          color: #FF6464;
        }
        &.orange {
          background: rgba(255,128,51,0.08);
          border: 1px solid rgba(255,120,0,0.2);
          color: #FF8033;
        }
        &.blue {
          background: rgba(110,136,227,0.08);
          border: 1px solid rgba(106,134,234,0.2);
          color: #6A86EA;
        }
      }
    }
    .score-list {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 46px;
      .score-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        .score-number {
          font-weight: 500;
          font-size: 18px;
          color: #2F333D;
          line-height: 18px;
        }
        .score-label {
          margin-top: 4px;
          font-size: 14px;
          color: #91999F;
          line-height: 14px;
        }
      }
    }
    .recommend {
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient( 270deg, #F2F7FF 0%, #F2F7FF 100%);
      border-radius: 2px 2px 0px 0px;
      font-size: 12px;
      color: #5F666E;
      line-height: 28px;
      padding: 0 24px;
      >img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .company {
        margin-left: 8px;
        margin-right: 4px;
        font-size: 12px;
        color: #2F333D;
        flex-shrink: 0;
      }
      .text {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/dialog/exclusive-service-dialog/cs-exclusive-service-card.vue